/** @typedef {'FREE' | 'HOBBY' | 'PRO' | 'ULTRA'} PlanId */

const PLAN_RANK = { FREE: 0, HOBBY: 1, PRO: 2, ULTRA: 3 };

/**
 * Normalize plan ids. Legacy `LIGHT` maps to `HOBBY`.
 * @param {string | null | undefined} status
 * @returns {PlanId}
 */
export function normalizePlan(status) {
  const raw = String(status || 'FREE').toUpperCase();
  if (raw === 'ULTRA') return 'ULTRA';
  if (raw === 'PRO') return 'PRO';
  if (raw === 'HOBBY' || raw === 'LIGHT') return 'HOBBY';
  return 'FREE';
}

export function planDisplayName(status) {
  const plan = normalizePlan(status);
  if (plan === 'ULTRA') return 'Ultra';
  if (plan === 'PRO') return 'Pro';
  if (plan === 'HOBBY') return 'Hobby';
  return 'Free';
}

export function planRank(status) {
  return PLAN_RANK[normalizePlan(status)] || 0;
}

export function isPaidPlan(status) {
  const plan = normalizePlan(status);
  return plan === 'HOBBY' || plan === 'PRO' || plan === 'ULTRA';
}

export function isHobbyPlan(status) {
  return normalizePlan(status) === 'HOBBY';
}

export function isProPlan(status) {
  return normalizePlan(status) === 'PRO';
}

export function isUltraPlan(status) {
  return normalizePlan(status) === 'ULTRA';
}

/** True when current plan already includes the feature tier of `other`. */
export function planIncludes(current, other) {
  return planRank(current) >= planRank(other);
}
